import * as commonScripts from '../common'
const cmpThreeCardsStandard = {
  component: null,
  init: function (element) {
    const _ = this
    _.component = element
    commonScripts.util.animationTranslate(this)
    commonScripts.util.inheritPermalink(element)
    const bg = _.component.querySelector('.cmp-three-cards-standard__bg')
    const primary = _.component.querySelector('.cmp-three-cards-standard__primary')

    function setSize () {
      const primaryHeight = primary.offsetHeight
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth
      if (viewportWidth >= 768) {
        bg.setAttribute('style', 'height: ' + primaryHeight + 'px')
      }
    }

    window.addEventListener('resize', setSize, false)
    window.addEventListener('load', setSize, false)
    window.addEventListener('orientationchange', setSize, false)
  }
}

export default cmpThreeCardsStandard 
